import { render, staticRenderFns } from "./ModifyPopup.vue?vue&type=template&id=6bc60e9d&scoped=true&"
import script from "./ModifyPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc60e9d",
  null
  
)

export default component.exports